<template>
  <div class="targeting-info-checkbox">
    <a-checkbox :checked="checked" v-a11y-tab @change="handleChange">{{ label }}</a-checkbox>
    <question-mark-popover v-if="popover" :message="popover" placement="right" />
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { SAVE_PRIVATE_INFO } from '@/store/privateInfo/actionTypes';
import QuestionMarkPopover from '@/components/common/QuestionMarkPopover.vue';

export default {
  props: {
    fieldName: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    popover: {
      type: String,
    },
  },
  components: {
    QuestionMarkPopover,
  },
  computed: {
    ...mapGetters(['privateInfo']),
    checked() {
      return this.privateInfo[this.fieldName];
    },
  },
  methods: {
    ...mapActions({
      save: SAVE_PRIVATE_INFO,
    }),
    handleChange() {
      this.save({ [this.fieldName]: !this.checked });
    },
  },
};
</script>

<style lang="scss" scoped>
@import '~@/assets/styles/colors.scss';

.targeting-info-checkbox {
  display: flex;
}
</style>
